import { useContext } from "react";
import { PermissionsContext } from "../../context/permissions/PermissionsContext";

export const usePermissions = () => useContext(PermissionsContext);
